<div
  class="btn-group language-selector"
  ngbDropdown
  placement="bottom-start"
  #dropdown="ngbDropdown"
  container="body"
>
  <!-- Trigger -->
  <button
    class="btn btn-link no-hover-style"
    ngbDropdownToggle
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen"
    type="button"
    (click)="toggleDropdown($event)"
  >
    <img
      *ngIf="selectedLanguage"
      [src]="selectedLanguage.flag"
      [alt]="selectedLanguage.name + ' flag'"
      class="flag-icon rounded-circle"
      [attr.aria-label]="selectedLanguage.name + ' flag'"
    />
  </button>

  <!-- Menu -->
  <div
    ngbDropdownMenu
    style="
      transform: translate(-52px, 12px);
      box-shadow: rgba(135, 135, 135, 0.5) -14px 14px 10px;
      position: absolute;
      top: 0px;
      left: 0px;
      will-change: transform;
      width: 200px !important;
    "
  >
    <div class="dropdown-menu-header-inner mt-0 pt-4 pb-4 bg-primary">
      <div class="menu-header-content text-center text-white">
        <h6 class="menu-header-subtitle mt-0">
          {{ "Left_Menu.ChooseLanguage" | translate }}
        </h6>
        <div></div>
        <!-- </div> -->
      </div>
    </div>

    <div
      type="button"
      class="dropdown-item text-start"
      *ngFor="let lang of languages"
      (click)="onChangeLanguage(lang.code)"
    >
      <img class="language-icon flag-icon-background me-2" [src]="lang.flag" />

      <span class="ms-2 ps-2">{{ lang.name | translate }}</span>
    </div>
  </div>
</div>
